import { Route, Routes } from 'react-router-dom';
import AppLayout from '../layout/AppLayout.tsx';
import ConfigurationEditComponent from '../components/features/configurationEdit/ConfigurationEdit.tsx';
import LoginComponent from '../components/features/login/Login.tsx';
import ProtectedRoute from '../ProtectedRoute.tsx';
import UsersComponent from '../components/features/users/Users.tsx';

function AppRoutes() {
  return (
    <Routes>

      <Route element = {<AppLayout />}>
          <Route path = "/login" element = {<LoginComponent/>} />
      </Route>

      <Route element = {<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/" />

          <Route path="/configuration/" element={<ConfigurationEditComponent />} />
          <Route path="/configuration/:configurationId" element={<ConfigurationEditComponent />} />
          <Route path="/configuration/:configurationId/Users" element={<UsersComponent />} />
          
        </Route>
      </Route>

    </Routes>
  );
}

export default AppRoutes;
